import CASL from '@/utils/constants/casl'

export default {
  path: 'delivery',
  children: [
    {
      path: '',
      name: 'delivery.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.DELIVERY
      },
      component: () => import('./list/DeliveryListPage.vue')
    },
    {
      path: ':uid',
      name: 'delivery.detail',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.DELIVERY
      },
      component: () => import('./form/DeliveryFormPage.vue')
    }
  ]
}
